var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("el-card", [
    _c("div", { staticClass: "card-content device-notes-tags" }, [
      _c(
        "div",
        { staticClass: "note" },
        [
          _c("h2", [_vm._v("Notes")]),
          _vm._v(" "),
          _vm.fetchingNotes.error.value
            ? _c("el-alert", {
                attrs: {
                  title: "Something went wrong",
                  type: "info",
                  description: "Try to reload this card",
                  "show-icon": "",
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _c("section", {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.fetchingNotes.working,
                expression: "fetchingNotes.working",
              },
            ],
          }),
          _vm._v(" "),
          _c(
            "transition-group",
            { attrs: { name: "fade" } },
            _vm._l(_vm.notes.comments, function (nt) {
              return _c("section", { key: nt.id }, [
                _c("p", [_vm._v(_vm._s(nt.content))]),
                _vm._v(" "),
                _c("div", { staticClass: "foot-note" }, [
                  _c("div", [
                    _c("span", [_vm._v("Added by")]),
                    _vm._v(" "),
                    _c("span", [_vm._v(" " + _vm._s(nt.user) + " - ")]),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm._f("moment")(nt.created_at, "DD/MM/YY HH:MM A")
                        )
                      ),
                    ]),
                    _vm._v(" "),
                    _c("i", {
                      class: {
                        "el-icon-loading":
                          nt.id === _vm.note.removingId && _vm.note.working,
                        "el-icon-delete": nt.id !== _vm.note.removingId,
                      },
                      on: {
                        click: function ($event) {
                          return _vm.removeNote(nt.id)
                        },
                      },
                    }),
                  ]),
                ]),
                _vm._v(" "),
                _c("br"),
              ])
            }),
            0
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "add-btn" },
            [
              _c(
                "el-popover",
                {
                  ref: "postnote",
                  attrs: { placement: "right", width: "444" },
                  model: {
                    value: _vm.note.visible,
                    callback: function ($$v) {
                      _vm.$set(_vm.note, "visible", $$v)
                    },
                    expression: "note.visible",
                  },
                },
                [
                  _c(
                    "div",
                    { staticClass: "new-note-text__textarea" },
                    [
                      _c("el-input", {
                        attrs: {
                          size: "medium",
                          type: "textarea",
                          disabled: _vm.note.working,
                          rows: 3,
                          placeholder: "Write your note",
                        },
                        model: {
                          value: _vm.note.text,
                          callback: function ($$v) {
                            _vm.$set(_vm.note, "text", $$v)
                          },
                          expression: "note.text",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticStyle: { "text-align": "right", margin: "0" } },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { size: "mini", type: "text" },
                          on: {
                            click: function ($event) {
                              return _vm.resetNote()
                            },
                          },
                        },
                        [_vm._v("\n              cancel\n            ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          attrs: {
                            loading: _vm.note.working,
                            type: "primary",
                            size: "mini",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.postNote()
                            },
                          },
                        },
                        [_vm._v("\n              save\n            ")]
                      ),
                    ],
                    1
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "popover",
                      rawName: "v-popover:postnote",
                      arg: "postnote",
                    },
                  ],
                  attrs: { type: "text" },
                },
                [_vm._v("\n          + Add Note\n        ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("hr"),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "tags" },
        [
          _c("h2", [_vm._v("Tags")]),
          _vm._v(" "),
          _vm.fetchingTags.error.value
            ? _c("el-alert", {
                attrs: {
                  title: "Something went wrong",
                  type: "info",
                  description: "Try to reload this card",
                  "show-icon": "",
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _c(
            "section",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.fetchingTags.working,
                  expression: "fetchingTags.working",
                },
              ],
            },
            _vm._l(_vm.tags, function (tag, index) {
              return _c(
                "el-tag",
                {
                  key: index,
                  attrs: { closable: "", type: "info" },
                  on: {
                    close: function ($event) {
                      return _vm.deleteTag(tag.text)
                    },
                  },
                },
                [_vm._v("\n          " + _vm._s(tag.text) + "\n        ")]
              )
            }),
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "add-btn" },
            [
              _c(
                "el-popover",
                {
                  ref: "addtag",
                  attrs: { placement: "right", width: "444" },
                  model: {
                    value: _vm.tag.visible,
                    callback: function ($$v) {
                      _vm.$set(_vm.tag, "visible", $$v)
                    },
                    expression: "tag.visible",
                  },
                },
                [
                  _c(
                    "div",
                    { staticClass: "new-note-text__textarea" },
                    [
                      _c("el-input", {
                        attrs: {
                          size: "medium",
                          placeholder: "Tag",
                          disabled: _vm.tag.working,
                        },
                        nativeOn: {
                          keyup: function ($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            return _vm.addTag()
                          },
                        },
                        model: {
                          value: _vm.tag.text,
                          callback: function ($$v) {
                            _vm.$set(_vm.tag, "text", $$v)
                          },
                          expression: "tag.text",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticStyle: { "text-align": "right", margin: "0" } },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { size: "mini", type: "text" },
                          on: {
                            click: function ($event) {
                              return _vm.resetTag()
                            },
                          },
                        },
                        [_vm._v("\n              cancel\n            ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          attrs: {
                            type: "primary",
                            size: "mini",
                            loading: _vm.tag.working,
                          },
                          on: {
                            click: function ($event) {
                              return _vm.addTag()
                            },
                          },
                        },
                        [_vm._v("\n              save\n            ")]
                      ),
                    ],
                    1
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "popover",
                      rawName: "v-popover:addtag",
                      arg: "addtag",
                    },
                  ],
                  attrs: { type: "text" },
                },
                [_vm._v("\n          + Add Tag\n        ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }